import api from '../lib/api'

export const listOrders = (tenantId, params = {}) =>
    api.get(`/admin/orders/${tenantId}`, { params }).then(r => r.data)

export const getOrder = (tenantId, orderId) =>
    api.get(`/admin/orders/${tenantId}/${orderId}`).then(r => r.data)

export const createOrder = (tenantId, data) =>
    api.post(`/admin/orders/${tenantId}`, data).then(r => r.data)

export const updateOrderStatus = (tenantId, orderId, status, by = 'dashboard', note = null) =>
    api.patch(`/admin/orders/${tenantId}/${orderId}/status`, { status, by, note }).then(r => r.data)

export const updateOrderPayment = (tenantId, orderId, data) =>
    api.patch(`/admin/orders/${tenantId}/${orderId}/payment`, data).then(r => r.data)

export const getRevenueStats = (tenantId) =>
    api.get(`/admin/tenants/${tenantId}/revenue-stats`).then(r => r.data)
